import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import Services from '../pages/services/page';
import ConstructionServices from '../pages/services/construction/page';
import OilServices from '../pages/services/oil/page';
import GoldServices from '../pages/services/gold/page';
import DefenseServices from '../pages/services/defense/page';
import ConsultingServices from '../pages/services/consulting/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/construction',
    element: <ConstructionServices />,
  },
  {
    path: '/services/oil',
    element: <OilServices />,
  },
  {
    path: '/services/gold',
    element: <GoldServices />,
  },
  {
    path: '/services/defense',
    element: <DefenseServices />,
  },
  {
    path: '/services/consulting',
    element: <ConsultingServices />,
  },
  // Redirect old routes to new ones
  {
    path: '/services/infrastructure',
    element: <ConstructionServices />,
  },
  {
    path: '/services/petroleum',
    element: <OilServices />,
  },
  {
    path: '/services/gold-trading',
    element: <GoldServices />,
  },
  {
    path: '/services/urban-development',
    element: <ConstructionServices />,
  },
  {
    path: '/services/contracts',
    element: <ConstructionServices />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;